import { CodeBook } from "@king-ict/eupisi-ui/models";

export interface CommitteeRole extends CodeBook {
  committeeType: CommitteeTypeEnum;
  sort: number;
  checkOIB: boolean;
}

export enum CommitteeRoleEnum {
  Physician = 1,
  PrimarySchoolTeacher,
  ProfessionalAssociatePedagogue = 4,
  ProfessionalAssociatePsychologist = 5,
  ProfessionalAssociateEducationalRehabilitator,
  ProfessionalAssociateSpeechTherapist,
  ProfessionalAssociateSocialPedagogue,
  TeacherEducationalRehabilitator,
  AssignedPsychologist,
  CroatianLanguageTeacher = 28, // Ucitelj hrvatskog jezika
  CroatianLanguageTeacherAssigned = 40, // Nastavnik hrvatskog jezika
}

export enum CommitteeTypeEnum {
  Institution = 1,
  County,
  Ministry,
  RegionalCommittee, // Stručno povjerenstvo ispostave
  InstitutionAssigned = 99,
}

export enum CommitteePosition {
  Member = 1,
  Deputy,
}
